import { Transition } from '@headlessui/react';
import { NoDocuments } from '@plato/ui-legacy/assets/icons/no-documents';
import { Button } from '@plato/ui-legacy/components/ui/button';
import { cn } from '@plato/ui/util/classes';
import { useTranslation } from 'react-i18next';
import { api } from '../../../../utils/api.ts';
import { useShowCreateTaskDialog } from '../../hooks/use-show-create-task-dialog.ts';

export function TaskEmptyContent() {
    const { t } = useTranslation();
    const showCreateTaskDialog = useShowCreateTaskDialog();

    const {
        data: taskCount,
        isLoading,
        error,
    } = api.platoUser.query.tasks.getManyTasks.count.useQuery(undefined);

    const handleCreateClick = () => {
        showCreateTaskDialog({ source: 'task_overview_page' });
    };

    if (error || isLoading) {
        return null;
    }

    return (
        <Transition
            show={taskCount === 0}
            enter="transition-opacity ease-linear"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
        >
            <div className={cn('flex flex-col items-center rounded-md py-2')}>
                <span className="text-sm text-neutral-800">
                    {t('tasks__empty_state__body', { ns: 'tasks' })}
                </span>
                <div>
                    <NoDocuments />
                </div>
                <div>
                    <Button variant="outline" onClick={handleCreateClick}>
                        {t('tasks__empty_state__create_task', { ns: 'tasks' })}
                    </Button>
                </div>
            </div>
        </Transition>
    );
}
